import _ from 'lodash';
import { getStringFromArray } from '../../../utils';

export default (options) => {
  let content = '';
  let checked = true;

  const joinContent = getStringFromArray('services', options);
  content = `${joinContent || '<u>select services</u>'} services for ${
    options.masters || '<u>number of masters</u>'
  } master(s) performed by ${options.artistName || '<u>artist name</u>.'}`;
  checked =
    joinContent !== '' &&
    options.producer &&
    options.masters !== '' &&
    options.artistName !== '';

  return { content, checked };
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/Services.js